// src/redux/slices/workflowSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/axiosInstance";
import Cookies from "js-cookie";

const initialState = {
  workflows: [],
  loading: false,
  error: null,
};

// Async thunk to fetch workflow list
export const fetchWorkflowList = createAsyncThunk(
  "workflow/fetchWorkflowList",
  async (_, { rejectWithValue }) => {
    try {
      const token = Cookies.get("_a_token");

      const response = await axiosInstance.get(
        "/v1/company/workflow_add",
        {
          authRequired: true,
        }
      );

      return response.data; // expected: { success: true, data: [ ... ] }
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

const workflowSlice = createSlice({
  name: "workflow",
  initialState,
  reducers: {
    clearWorkflowError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWorkflowList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWorkflowList.fulfilled, (state, action) => {
        state.loading = false;
        state.workflows = action.payload?.data || [];
      })
      .addCase(fetchWorkflowList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch workflows";
      });
  },
});

export const { clearWorkflowError } = workflowSlice.actions;
export default workflowSlice.reducer;
